module.exports = __webpack_public_path__ + "static/media/3.a11f9ece.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/trolls-girl/bracelet/3.png
// module id = 92
// module chunks = 0